<ng-container *ngFor="let field of fields">

  <!-- Type field -->
  <div class="form-group" *ngIf="field.model.input === 'list' && field.name === 'type' && field.model.valuesList.length > 1">
    <label for="{{ field.name }}">{{ field.model.label }}</label>
    <t-select [items]="field.model.valuesList" [(item)]="field.value" (updated)="buildForm()"></t-select>
    <span class="info info-right">{{ link.name }}.{{ field.name }}</span>
  </div>

  <!-- List field -->
  <div class="form-group" *ngIf="field.model.input === 'list' && field.name !== 'type'">
    <label for="{{ field.name }}">{{ field.model.label }}</label>
    <t-select [items]="field.model.valuesList" [(item)]="field.value"></t-select>
    <span class="info info-right">{{ link.name }}.{{ field.name }}</span>
  </div>

  <!-- Text field -->
  <div class="form-group" *ngIf="field.model.input === 'text'">
    <label for="{{ field.name }}">{{ field.model.label }}</label>

    <input  *ngIf="!field.control" id="{{ field.name }}" type="text" [(ngModel)]="field.value" />

    <input *ngIf="field.control" id="{{ field.name }}" type="text" [formControl]="field.control" maxlength="200"/>
    <span *ngIf="field.control" class="info info-error" [hidden]="field.control.valid || field.control.pristine || !field.control.errors.required">Ce champ est requis</span>
    <span class="info info-right">{{ link.name }}.{{ field.name }}</span>

    <div class="inpi-field-alert" *ngIf="field.inpiFieldError && field.value !== field.inpiFieldError.valid">
      <span>Ce champ ne correspond pas aux données INPI</span>
      <input type="text" readonly [value]="field.inpiFieldError.valid" />
      <a class="btn btn-small btn-gray" (click)="fixInpiError($event, field)">
        <t-icon name="check"></t-icon>
        <span class="text">Corriger</span>
      </a>
    </div>
  </div>

  <!-- Boolean field -->
  <div class="form-group" *ngIf="field.model.input === 'boolean'">
    <label for="{{ field.name }}">{{ field.model.label }}</label>
    <t-option [options]="booleanOptions" [(value)]="field.value"></t-option>
    <span class="info info-right">{{ link.name }}.{{ field.name }}</span>
  </div>

  <!-- Shares sub-form -->
  <div class="form-group-shares" *ngIf="field.model.input === 'shares'">

      <div class="warning" *ngIf="!totalShares || totalShares <= 0">
        <t-icon name="warning"></t-icon>
        <div class="message">
          Nombre de titres non spécifié dans la société
        </div>
        <a class="btn btn-small btn-primary" (click)="onFixIssue()">
          <t-icon name="mode_edit"></t-icon>
          <span class="text">Modifier</span>
        </a>
      </div>

      <ng-container *ngFor="let field of sharesFields">

        <div class="form-group">
          <label for="{{ field.name }}">{{ field.model.label }}</label>
          <div style="display: flex">
            <input *ngIf="field.control" id="{{ field.name }}" type="text" [formControl]="field.control"/>
            <t-percent [total]="totalShares" [value]="field.value"></t-percent>
          </div>
          <span *ngIf="field.control" class="info info-error" [hidden]="field.control.valid || field.control.pristine || !field.control.errors.pattern">Ce champ est numérique</span>
          <span class="info info-right">{{ link.name }}.{{ field.name }}</span>
        </div>

      </ng-container>console.log(field.name);

      <div class="form-group form-group-shares-total">
        <label for="{{ field.name }}">{{ field.model.label }}</label>
        <div style="display: flex">
          <input *ngIf="field.control" id="{{ field.name }}" type="text" [formControl]="field.control" />
          <t-percent [total]="totalShares" [value]="field.value"></t-percent>
        </div>
        <span *ngIf="field.control" class="info info-error" [hidden]="field.control.valid || field.control.pristine || !field.control.errors.pattern">Ce champ est numérique</span>
        <span class="info info-right">{{ link.name }}.{{ field.name }}</span>
      </div>

      <div class="form-group form-group-shares-total-all" *ngIf="totalShares && totalShares > 0">
        Nombre total de titres de la société: <span>{{ totalShares }}</span>
      </div>

  </div>

</ng-container>